module.exports = __webpack_public_path__ + "img/add_enclosure.f7149243.svg";